import { Object3D } from "three";
import { MeshInfo } from "../../Meshes/MeshInfo";

export class BoxObject extends Object3D {

    public MeshInfo?: MeshInfo;

    constructor() {
        super();
    }
}
